import { h, Component } from 'preact';
import { accessNested, joinClasses, parseDate } from 'utils/utils';
import s from 'components/bolt/countdown/countdown.sss';

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

function isDate(date) {
	return date instanceof Date && !isNaN(date);
}
function parseOffset(value) {
	if (value == undefined) {
		return null;
	}
	if (!Number.isNaN(+value) && Math.abs(value) < 15) {
		// Decimal format: -3.5
		return 60 * value;
	}
	if (typeof value === 'string') {
		// Regular format: -3:30 or 0800
		let match = value.trim().match(/^([+-]?)(\d\d??)(?::?(\d\d))?$/);
		if (!match) {
			return null;
		}
		let sign = match[1] === '-' ? -1 : +1;
		let hours = +match[2];
		let minutes = +match[3] || 0;
		return sign * (60 * hours + minutes);
	}
	return null;
}

export default class Countdown extends Component {
	constructor(props) {
		super(props);

		this.state = {
			remaining: { days: 0, hours: 0, minutes: 0, seconds: 0 },
			counting: false
		};

		this.target = parseDate(props.datetime);
		let valid = isDate(this.target);
		if (valid) {
			let offsetAmount = parseOffset(props.timeOffset);
			if (offsetAmount !== null) {
				this.target.setMinutes(this.target.getMinutes() - this.target.getTimezoneOffset() - offsetAmount);
			}
		} else {
			console.error('Invalid Date! The "Target Date and Time" item isn\'t formatted correctly in Thundr: ' + props.datetime);
			this.target = null;
		}

		this.startTimer = this.startTimer.bind(this);
		this.stopTimer = this.stopTimer.bind(this);
		this.updateTime = this.updateTime.bind(this);
	}

	componentDidMount() {
		this.startTimer();
	}

	startTimer() {
		clearInterval(this.timer);
		this.counting = true;
		this.updateTime();
		this.timer = setInterval(this.updateTime, 1000);
		this.setState({ counting: true });
	}

	stopTimer() {
		clearInterval(this.timer);
		this.counting = false;
		this.setState({ counting: false });
	}

	updateTime() {
		if (!this.target) {
			return this.stopTimer();
		}

		let diff = Math.max(this.target - Date.now(), 0);
		const seconds = Math.floor((diff / SECOND) % 60);
		const minutes = Math.floor((diff / MINUTE) % 60);
		const hours = Math.floor((diff / HOUR) % 24);
		const days = Math.floor(diff / DAY);

		if (!diff) {
			this.stopTimer();
		}

		this.setState({
			remaining: { days, hours, minutes, seconds }
		});
	}

	renderValue(value, copy, defaultLabel) {
		const label = accessNested(this.props, ['appData', 'copy', 'baseCopy', '$DATETIME_LOCALE', copy], defaultLabel);

		if (defaultLabel !== 'Days' || value <= 99) {
			value = ('0' + value).slice(-2);
		}

		return (
			<div class={joinClasses(s.denomination, typeof value === 'number' && s.wide)}>
				<div class={joinClasses(s.value, 'h1')}>{value}</div>
				<div class={s.label}>{label}</div>
			</div>
		);
	}

	render({ annotation, hidden, visible, position, headerHeight }, { remaining, counting }) {
		const { days, hours, minutes, seconds } = remaining;
		const containerStyle = {
			paddingTop: position === 'top' && `${headerHeight + 24}px`
		};

		return (
			<div
				style={containerStyle}
				class={joinClasses(s.wrapper, !counting && s.remove, hidden && s.hide, visible && s.visible)}
			>
				{annotation && <div class={joinClasses(s.annotation, 'mediumB')}>{annotation}</div>}
				<div class={s.countdown}>
					{this.renderValue(days, '$LABEL_DAYS', 'Days')}
					{this.renderValue(hours, '$LABEL_HOURS', 'Hours')}
					{this.renderValue(minutes, '$LABEL_MINUTES', 'Minutes')}
					{this.renderValue(seconds, '$LABEL_SECONDS', 'Seconds')}
				</div>
			</div>
		);
	}
}
